/*! jQuery Validation Plugin - v1.21.0 - 7/17/2024
 * https://jqueryvalidation.org/
 * Copyright (c) 2024 Jörn Zaefferer; Licensed MIT */
!function (a) {
  "function" == typeof define && define.amd ? define(["jquery", "../jquery.validate.min"], a) : "object" == typeof module && module.exports ? module.exports = a(require("jquery")) : a(jQuery);
}(function (a) {
  return a.extend(a.validator.messages, {
    required: "Aquest camp és obligatori.",
    remote: "Si us plau, omple aquest camp.",
    email: "Si us plau, escriu una adreça de correu-e vàlida.",
    url: "Si us plau, escriu una URL vàlida.",
    date: "Si us plau, escriu una data vàlida.",
    dateISO: "Si us plau, escriu una data (ISO) vàlida.",
    number: "Si us plau, escriu un número enter vàlid.",
    digits: "Si us plau, escriu només dígits.",
    creditcard: "Si us plau, escriu un número de tarjeta vàlid.",
    equalTo: "Si us plau, escriu el mateix valor de nou.",
    extension: "Si us plau, escriu un valor amb una extensió acceptada.",
    maxlength: a.validator.format("Si us plau, no escriguis més de {0} caracters."),
    minlength: a.validator.format("Si us plau, no escriguis menys de {0} caracters."),
    rangelength: a.validator.format("Si us plau, escriu un valor entre {0} i {1} caracters."),
    range: a.validator.format("Si us plau, escriu un valor entre {0} i {1}."),
    max: a.validator.format("Si us plau, escriu un valor menor o igual a {0}."),
    min: a.validator.format("Si us plau, escriu un valor major o igual a {0}.")
  }), a;
});